module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-for-use@2x.a6fa3af9.jpg";